import React, {ChangeEventHandler, KeyboardEventHandler, useCallback, useEffect, useRef, useState} from 'react'
import {CFValue} from 'module/CustomField/type/CFType'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {cssCFInput} from 'module/CustomField/style/cssCFInput'
import {Key} from 'util/Key'
import {getCFAttrTextAlignCSS} from 'module/CustomField/style/CFAlignmentStyle'

type Props = {
	adaptValueToView: (rawValue: CFValue) => string
	adaptValueToModel: (viewValue: string) => CFValue
} & CFComponentProps<CFValue>

/* Wrap this in your CustomField with the matching conversion methods*/
export function AdaptCFValueInputComponent(props: Props) {
	const {adaptValueToView, adaptValueToModel, rawValue, cfDef, setCb} = props
	const ref = useRef<HTMLInputElement>(null)
	const [viewValue, setViewValue] = useState('')

	useEffect(() => {
		setViewValue(adaptValueToView(rawValue))
	}, [adaptValueToView, rawValue])

	const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>((evt) => {
		setViewValue(adaptValueToView(evt.target.value))
	}, [adaptValueToModel, rawValue])

	const onFocus = useCallback(() => {
		ref.current?.select()
	}, [ref.current])

	const onKeyDown = useCallback<KeyboardEventHandler<HTMLInputElement>>((event) => {
		switch (event.key) {
			case Key.Escape:
				setViewValue(adaptValueToView(rawValue))
				break;
		}
	}, [adaptValueToView, rawValue]);

	const onBlur = useCallback(() => {
		setViewValue(adaptValueToView(rawValue))
		setCb(adaptValueToModel(viewValue))
	}, [adaptValueToModel, viewValue])

	return <input
		ref={ref}
		css={[
			cssCFInput,
			getCFAttrTextAlignCSS(cfDef),
		]}
		value={viewValue}
		onChange={onChange}
		onFocus={onFocus}
		onKeyDown={onKeyDown}
		onBlur={onBlur}
	/>
}